import React from 'react';
import PublicLayout, { LegalShell, PUBLIC_CONTACT_EMAIL } from '../../components/layout/PublicLayout';

const AccountDataDeletion = () => (
  <PublicLayout title="Account & Data Deletion" description="How to request deletion of your VSKR Legal or LIOS account and associated data.">
    <LegalShell title="Account & Data Deletion" updated="December 2025">
      <p>This page explains how to request deletion of your account and associated data for VSKR Legal services, including LIOS.</p>

      <h2>Who may request deletion</h2>
      <p>The account holder may request deletion of their own account and associated data.</p>

      <h2>How to submit a request</h2>
      <p>Send an email to <a href={`mailto:${PUBLIC_CONTACT_EMAIL}`} className="text-[#2D8CFF] hover:underline">{PUBLIC_CONTACT_EMAIL}</a> from the email address associated with your account, with the subject line <strong>"Account &amp; Data Deletion Request"</strong>. Please include the product (for example, LIOS) and the account email.</p>

      <h2>Identity verification</h2>
      <p>To protect your account, we may ask you to verify your identity before processing a deletion request — for example, by confirming the request from your registered email address.</p>

      <h2>Account deletion vs. specific data</h2>
      <ul>
        <li><strong>Account deletion</strong> removes your account and associated personal data from active systems.</li>
        <li><strong>Specific data deletion</strong> lets you ask us to remove particular content while keeping your account active.</li>
      </ul>
      <p>Please tell us which you would like when you contact us.</p>

      <h2>Data that may be retained</h2>
      <p>Certain limited information may be retained where required for legal, security, or operational reasons (for example, records needed to prevent fraud or comply with law). Such retained data is kept only as long as necessary.</p>

      <h2>How we will respond</h2>
      <p>We will acknowledge your request and communicate with you by email regarding its status. Deletion requests are currently handled through this supported request process.</p>

      <h2>Support</h2>
      <p>If you need help with a request, contact <a href={`mailto:${PUBLIC_CONTACT_EMAIL}`} className="text-[#2D8CFF] hover:underline">{PUBLIC_CONTACT_EMAIL}</a> or visit our <a href="/help" className="text-[#2D8CFF] hover:underline">Help &amp; Support</a> page.</p>
    </LegalShell>
  </PublicLayout>
);

export default AccountDataDeletion;
